import { theme } from "@config/theme"
import { rem } from "polished"
import styled from "styled-components"

export const Amount = styled.span`
  display: flex;
  align-items: center;
  justify-content: center;
  background: ${theme.colors.card.active};
  color: ${theme.colors.text.light};
  transition: all 0.2s ease-in-out;
  font-size: ${rem(11)};
  height: 1.5rem;
  min-width: 1.5rem;
  padding: 0 0.5rem;
  margin-left: ${rem(10)};
  border-radius: 0.75rem;
`

export const Button = styled.button`
  outline: 0;
  scroll-snap-align: start;
  text-decoration: none;
  transition: all 0.2s ease-in-out;
  position: relative;
  cursor: pointer;
  background: none;
  padding: 0.75rem 1.5rem;
  display: flex;
  align-items: center;
  justify-content: center;
  outline: 0;
  border: 1px solid ${theme.colors.softGrey};
  color: ${theme.colors.text.light};
  height: ${rem(50)};
  margin-right: 1rem;

  &[data-status="active"] {
    border: 1px solid ${theme.colors.purple};
    color: ${theme.colors.purple};

    ${Amount} {
      background: ${theme.colors.purple};
      color: white;
    }
  }

  &[data-status="idle"] {
    &:hover {
      color: ${theme.colors.purple};
    }
  }

  &[data-status="disabled"] {
    opacity: 0.3;
    cursor: not-allowed;
    pointer-events: none;
  }
`
